<template>
    <section class="layout">
        <ds-modal
            :is-open="isViewFormModalOpen"
            class="regular-modal"
            show-close
            :sub-title="subTitle"
            :title="modalTitle"
            @close="viewClose"
        >
            <div class="layout">
                <div v-if="!openForm">
                    <div v-for="(form, j) in listFormDetails" :key="j">
                        <p class="field-label">
                            {{ form.fieldLabel }}
                        </p>

                        <p v-if="!form.fieldValue">
                            None
                        </p>

                        <p v-if="form.fieldValue">
                            {{ form.fieldValue }}
                        </p>
                    </div>
                </div>

                <div v-if="openForm" data-qa="formCustomField">
                    <div v-for="(form, i) in formDetails" :key="i">
                        <ds-input-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.TEXT) "
                            v-model="form.value"
                            data-qa="formCustomField_TEXT"
                            :required="form.required"
                            :label="form.name"
                        />

                        <ds-input-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.TEXTS) "
                            v-model="form.value"
                            data-qa="formCustomField_TEXTS"
                            :required="form.required"
                            :label="form.name"
                        />

                        <ds-input-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.PASSWORD) "
                            v-model="form.value"
                            data-qa="formCustomField_PASSWORD"
                            :required="form.required"
                            :label="form.name"
                            :type="form.type"
                        />

                        <ds-input-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.WEBSITE)"
                            v-model="form.value"
                            data-qa="formCustomField_WEBSITE"
                            :required="form.required"
                            :label="form.name"
                        />

                        <ds-input-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.WHOLE_NUMBER)"
                            v-model.trim="form.value"
                            data-qa="formCustomField_WHOLE_NUMBER"
                            type="number"
                            :label="form.name"
                            :required="form.required"
                        />

                        <ds-input-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.PERCENT)"
                            v-model.trim="form.value"
                            data-qa="formCustomField_PERCENT"
                            class="input-field"
                            type="number"
                            :label="form.name"
                        />

                        <ds-input-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.PHONE_NUMBER)"
                            :ref="`phone${index}`"
                            v-model.trim="form.value"
                            data-qa="formCustomField_PHONE_NUMBER"
                            class="input-field"
                            type="tel"
                            :label="form.name"
                        />

                        <ds-input-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.DECIMAL_NUMBER)"
                            v-model.trim="form.value"
                            data-qa="formCustomField_DECIMAL_NUMBER"
                            class="input-field"
                            :label="form.name"
                        />

                        <ds-input-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.YEAR)"
                            v-model.trim="form.value"
                            data-qa="formCustomField_YEAR"
                            class="input-field"
                            type="number"
                            :label="form.name"
                            :required="form.required"
                        />

                        <ds-input-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.SSN)"
                            v-model="form.value"
                            data-qa="formCustomField_SSN"
                            class="input-field"
                            type="text"
                            :label="form.name"
                            :required="form.required"
                        />

                        <ds-input-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.CURRENCY)"
                            :ref="`currency${index}`"
                            v-model.trim="form.value"
                            data-qa="formCustomField_CURRENCY"
                            type="number"
                            :step="0.01"
                            :label="form.name"
                            :required="form.required"
                        />

                        <ds-date-picker
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.DATE)"
                            v-model="form.value"
                            data-qa="formCustomField_DATE"
                            :label="form.name"
                            :name="`custom-field-${form.id}`"
                            date-only
                            :required="form.required"
                        />

                        <ds-date-picker
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.DATETIME)"
                            v-model="form.value"
                            data-qa="formCustomField_DATETIME"
                            class="input-field"
                            time
                            :label="form.name"
                            :required="form.required"
                            :intercept-on-update="interceptInput(form)"
                        />

                        <div v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.RADIO)" class="allign-radio">
                            <p>{{ form.name }}</p>
                            <ds-radio-group
                                v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.RADIO)"
                                v-model="form.value"
                                class="allign"
                                data-qa="formCustomField_RADIO"
                                :required="form.required"
                                :options="formatOptions(form.options)"
                                :label="form.name"
                            />
                        </div>

                        <div v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.RADIOS)" class="allign-radio">
                            <p>{{ form.name }}</p>

                            <ds-radio-group
                                v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.RADIOS)"
                                v-model="form.value"
                                class="allign"
                                data-qa="formCustomField_Radio"
                                :required="form.required"
                                :options="formatOptions(form.options)"
                                :label="form.name"
                            />
                        </div>

                        <ds-select-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.OPTION)"
                            v-model.trim="form.value"
                            bind-value-only
                            data-qa="formCustomField_Dropdown"
                            :label="form.name"
                            :required="form.required"
                            :options="dropDowns(form.options)"
                        />

                        <ds-select-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.SELECT)"
                            v-model.trim="form.value"
                            class="input-field"
                            bind-value-only
                            data-qa="formCustomField_SELECT"
                            searchable
                            :label="form.name"
                            :options="dropDowns(form.options)"
                            :required="form.required"
                        />

                        <ds-select-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.DAY_OF_WEEK)"
                            v-model="form.value"
                            class="input-field"
                            label-prop="label"
                            value-prop="value"
                            bind-value-only
                            data-qa="formCustomField_WEEK"
                            searchable
                            :label="form.name"
                            :options="dropDownsMonth(form.options)"
                            :required="form.required"
                        />

                        <ds-select-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.USER)"
                            v-model="form.value"
                            class="input-field"
                            label-prop="label"
                            value-prop="value"
                            bind-value-only
                            data-qa="formCustomField_USER"
                            :label="form.name"
                            :options="dropDowns(form.options)"
                            :required="form.required"
                        />

                        <ds-select-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.YES_NO)"
                            v-model="form.value"
                            class="input-field"
                            label-prop="label"
                            value-prop="value"
                            bind-value-only
                            data-qa="formCustomField_YES_NO"
                            :label="form.name"
                            :options="formatYesNoOptions(form.options)"
                            :required="form.required"
                        />

                        <ds-select-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.MONTH)"
                            v-model="form.value"
                            class="input-field"
                            label-prop="label"
                            value-prop="value"
                            bind-value-only
                            data-qa="formCustomField_MONTH"
                            searchable
                            :label="form.name"
                            :options="dropDownsMonth(form.options)"
                            :required="form.required"
                        />

                        <ds-select-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.STATE)"
                            v-model="form.value"
                            class="input-field"
                            label-prop="label"
                            value-prop="value"
                            bind-value-only
                            data-qa="formCustomField_STATE"
                            searchable
                            :label="form.name"
                            :options="dropDowns(form.options)"
                            :required="form.required"
                        />

                        <ds-select-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.DRILLDOWN)"
                            v-model="form.value"
                            bind-value-only
                            data-qa="formCustomField_DRILLDOWN"
                            :label="form.name"
                            :required="form.required"
                            :options="dropDownsMonth(form.options)"
                        />

                        <ds-checkbox
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.CHECKBOX)"
                            v-model="form.value"
                            data-qa="formCustomField_Checkbox"
                            :label="form.name"
                            :required="form.required"
                        />

                        <ds-text-area-field
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.TEXT_AREA)"
                            v-model="form.value"
                            data-qa="formCustomField_TextareaField"
                            :required="form.required"
                            :maxlength="65000"
                            auto-grow
                            :label="form.name"
                        />

                        <p v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.HEADER)">
                            <!-- eslint-disable vue/no-v-html -->
                            <span class="status-message" v-html="form.value" />
                            <!-- eslint-enable vue/no-v-html -->
                        </p>

                        <div v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.IMAGE)">
                            <!-- eslint-disable vue/no-v-html -->
                            <span class="status-message" v-html="form.value" />
                            <!-- eslint-enable vue/no-v-html -->

                            <img :src="form.value" />
                        </div>

                        <div v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.LOGO)">
                            <!-- eslint-disable vue/no-v-html -->
                            <span class="status-message" v-html="form.value" />
                            <!-- eslint-enable vue/no-v-html -->

                            <ds-logo :src="form.value" />
                        </div>
                        <p v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.PARAGRAPH)">
                            <!-- eslint-disable vue/no-v-html -->
                            <span class="status-message" v-html="form.value" />
                            <!-- eslint-enable vue/no-v-html -->
                        </p>

                        <ds-multiselect
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.MULTISELECT)"
                            v-model="form.value"
                            data-qa="formCustomField_MULTISELECT"
                            class="input-field"
                            bind-value-only
                            multiple
                            searchable
                            :placeholder="form.name"
                            :options="dropDowns(form.options)"
                        />

                        <ds-multiselect
                            v-if="fieldType(form.type,ContactCustomFieldType.CUSTOM_FIELD_TYPES.USER_MULTISELECT)"
                            v-model="form.value"
                            data-qa="customField_USER_MULTISELECT"
                            class="input-field"
                            bind-value-only
                            multiple
                            searchable
                            :placeholder="form.name"
                            :options="dropDowns(form.options)"
                            :required="form.required"
                        />
                    </div>

                    <ds-button
                        data-qa="update-form"
                        :loading="saving"
                        @click="updateform"
                    >
                        Save
                    </ds-button>
                </div>
            </div>
        </ds-modal>
    </section>
</template>

<script>
import ContactCustomFieldType from './ContactCustomFieldType';
import axios from 'axios';
import moment from 'moment';

export default {
    props: {
        listFormDetails: Array,
        contact: Object,
        formDetails: Array,
        editFormName: String,
    },
    data() {
        return {
            ContactCustomFieldType,
            modalTitle: '',
            subTitle: '',
            formType: '',
            saving: false,
            yesNo: [
                { label: 'No', value: 'No' },
                { label: 'Yes', value: 'Yes' },
            ],
            yesNoSelected: [
                { label: 'Not selected', value: null },
                { label: 'No', value: 'No' },
                { label: 'Yes', value: 'Yes' },
            ],
            formId: 0,
            isViewFormModalOpen: false,
        };
    },

    created() {
        this.subTitle = this.fullName;
    },

    computed: {
        fullName() {
            return `${this.contact?.firstName} ${this.contact?.lastName}`;
        },

        openForm() {
            this.formsType(this.formType);

            return this.formType === 'edit';
        },
    },

    methods: {
        showModal(formType, id) {
            this.formType = formType;
            this.formId = Number(id);

            this.isViewFormModalOpen = true;
        },

        viewClose() {
            this.isViewFormModalOpen = false;
        },

        formsType(type) {
            if (type === 'edit') {
                this.modalTitle = this.editFormName;
            }

            if (type === 'view' && this.listFormDetails.map((item) => item.formName)[0] !== undefined) {
                this.modalTitle = this.listFormDetails.map((item) => item.formName)[0].toString();
            }
        },

        formatOptions(options) {
            const allOptions = [...options];
            const resultOptions = [];

            allOptions.forEach((option) => {
                resultOptions.push({ value: option.name, label: option.name });
            });

            return resultOptions;
        },

        fieldType(field, type) {
            return field === type;
        },

        formatYesNoOptions(customField) {
            return customField.fieldValue === null ? this.yesNoSelected : this.yesNo;
        },

        modalClose() {
            this.modalTitle = '';
            this.nestedModal_reset();
            this.isViewFormModalOpen = false;
        },

        async updateform() {
            this.saving = true;

            const message = 'Saved Form Details';

            try {
                await axios.put(`/app/webformSubmission/forms/${this.formId}/${this.contact.id}`, this.formDetails);

                this.$toast({ message });

                this.$root.$emit('GET_ALL_FORMS', true);

                this.modalClose();
            } catch (error) {
                this.$error({ message: 'Something went wrong and we couldn\'t save this Form details. Please try again.' });
                this.saving = false;
            }
        },

        interceptInput(field) {
            if (field && field.value && field.type === 'DateTime') {
                field.value = this.formatDateTimeField(field.value, 'YYYY-MM-DD HH:mm');
            }
        },

        formatDateTimeField(date, format = 'll') {
            const formattedDate = moment(date).isValid() ? date : new Date(date);

            return moment(formattedDate).format(format);
        },

        nestedModal_reset() {
            this.modalTitle = '';
            this.saving = false;
        },

        dropDowns(options) {
            options = options && Object.keys(options).map((key) => {
                return { label: options[key].name, value: options[key].name };
            });

            return options;
        },

        dropDownsMonth(options) {
            options = options && Object.keys(options).map((key) => {
                return { label: options[key].name, value: options[key].name };
            });

            return options;
        },
    },
};
</script>

<style lang="scss" scoped>
.field-label {
    font-size: small;
    color: $color-gray-80;
    margin-bottom: auto;
}

.allign {
    margin-bottom: 0.33rem;
}

.allign-radio {
    display: inline-flex;
    margin-right: 0.33rem;
}
</style>
